import logoNTT from "../../../../images/logo-ntt.svg";
import { x } from '@xstyled/styled-components';
import * as React from 'react';
export default {
  logoNTT,
  x,
  React
};